<template>
  <b-row>
    <b-col
      cols="12"
      md="6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">

              <!-- Nama -->
              <b-form-group
                label="Nama"
                label-for="v-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama"
                  rules="required"
                >
                  <b-form-input
                    id="v-name"
                    v-model="form.name"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Guard Nama -->
              <b-form-group
                label="Guard Name"
                label-for="v-guard_name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Guard Name"
                  rules="required"
                >
                  <v-select
                    v-model="form.guard_name"
                    label="Guard Name"
                    :options="guardOptions"
                    :state="errors.length > 0 ? false : null"
                  >
                    <template #no-options="">
                      Guard Name tidak ditemukan.
                    </template>
                  </v-select>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- Button -->
              <div class="d-flex justify-content-end mt-3">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  type="submit"
                  variant="primary"
                  :disabled="isSubmitting"
                >
                  <b-spinner
                    v-if="isSubmitting"
                    small
                  />
                  {{ isSubmitting ? "Menyimpan" : "Simpan" }}
                </b-button>
              </div>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

// Quill Editor
// eslint-disable-next-line
import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        name: '',
        guard_name: '',
      },
      required,
      isPending: false,
      isSubmitting: false,
      guardOptions: ['web', 'api'],
    }
  },
  computed: {
    ...mapState('permission', ['permission']),
    permissionId() {
      if (this.isEdit) {
        return this.$route.params.id
      }
      return null
    },
  },
  async created() {
    this.isPending = true

    if (this.isEdit) {
      await this.getPermission({ id: this.permissionId })
      this.fillData()
    }

    this.isPending = false
  },
  methods: {
    ...mapActions('permission', ['createPermission', 'updatePermission', 'getPermission']),
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      if (!this.isEdit) {
        await this.createPermission(this.form)
      } else {
        await this.updatePermission({ permissionId: this.permissionId, data: this.form })
      }

      this.isSubmitting = false
      this.$router.push('/permissions')
    },
    // Edit State Only
    fillData() {
      this.form.name = this.permission.data.name
      this.form.guard_name = this.permission.data.guard_name
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss">
.image-preview {
    width: 102px;
    height: 102px;
    background-color: white;
    border: 1px solid red;
    position: relative;
    img {
        left: 0;
        top: 0;
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
